import React, {useState} from "react";
import {Input} from "../../../styles/Forms";
import {Grid, Col} from "../../../styles/Grid";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";
import {AppButton} from "../../../styles/Butttons";
import styled from "styled-components";
import {CreateCourseService} from "../../../services/CoursesServices";
import {useHistory, useParams} from "react-router-dom";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import AppLoader from "../../../components/loaders/Loader";

export default function FormPartOne({save, sections, setData, continueAction, dataCourse}) {
   const [graduateText, setGraduateText] = useState("");
   const [isSavigData, setSaving] = useState(false);
   let history = useHistory();
   let {type} = useParams();

   function Create(e) {
      e.preventDefault();
      let form = e.target.elements;
      let dataSend = new FormData();
      setSaving(true);
      if (dataCourse.idCourse) {
         continueAction();
         return setSaving(false);
      }

      dataSend.append("idCourseType", type);
      dataSend.append("visible", true);
      dataSend.append("token", localStorage.getItem("domecq_token"));
      dataSend.append("shortDescription", form.shortDescription.value);
      dataSend.append("courseName", form.courseName.value);
      dataSend.append("courseCode", form.courseCode.value);
      dataSend.append("longDescription", form.longDescription.value.replace(/\n/g, "<br>"));
      dataSend.append("graduateProfile", graduateText + "");
      dataSend.append("startDate", form.startDate.value);
      dataSend.append("endDate", form.endDate.value);
      dataSend.append("linkEventBrite", form.linkEventBrite.value);
      dataSend.append("pathImageDesktop", form.pathImageDesktop.files[0]);
      dataSend.append("pathImageMobile", form.pathImageMobile.files[0]);

      CreateCourseService(dataSend)
         .then((res) => res.json())
         .then((resp) => {
            const {status, data} = resp;
            if (status === "error") throw new Error("Erro");
            setData({...data});
            return data;
         })
         .then((data) => {
            if (sections.length > 1) {
               history.replace(`/offer/edit/${type}/${data.idCourse}`, {page: 2});
            } else {
               history.goBack();
            }
         })
         .then(() => {
            setSaving(false);
         })
         .catch((e) => {
            console.log(e);
            setSaving(false);
         });
   }
   return (
      <>
         <FormStyled onSubmit={Create}>
            <Grid>
               <Col large={3}>
                  <Input required type="text" placeholder="Nombre del curso" name="courseName" />
               </Col>
               <Col large={3} offsetL={0.5}>
                  <Input required type="text" placeholder="Código del certificado" name="courseCode" />
               </Col>
               <Col large={5} offsetL={0.5}>
                  <Grid>
                     <Col large={5}>
                        <Input required type="date" name="startDate" />
                     </Col>
                     <Col large={2} />
                     <Col large={5}>
                        <Input required type="number" name="endDate" step="any" placeholder="horas" />
                     </Col>
                  </Grid>
               </Col>
            </Grid>

            <Col className="maxMargin">
               <Col large={12}>
                  <Grid>
                     <Col large={6}>
                        <Col large={12}>
                           <Label>Link Eventbrite:</Label>
                        </Col>
                        <Col large={12}>
                           <Input required type="url" name="linkEventBrite" />
                        </Col>
                     </Col>
                  </Grid>
               </Col>
            </Col>

            {/* Segúnda página */}

            <Col className="maxMargin">
               <Col large={12}>
                  <Grid>
                     <Col large={6} className="imgs">
                        <Label>Imágen Desktop:</Label>
                        <EditableImg editable={true} label="Medidas aprox: 394px X 317px" name="pathImageDesktop" />
                     </Col>
                     <Col large={6} className="imgs">
                        <Label>Imágen Mobile</Label>
                        <EditableImg editable={true} label="Medidas aprox: 394px X 317px" name="pathImageMobile" />
                     </Col>
                  </Grid>
               </Col>
            </Col>
            <Grid className="maxMargin">
               <Col large={4}>
                  <Grid>
                     <Col large={12}>
                        <Label>Descripción corta del curso:</Label>
                     </Col>
                     <Col large={12}>
                        <Input required type="text" placeholder="Texto" className="short" name="shortDescription" as="textarea" />
                     </Col>
                  </Grid>
               </Col>
               <Col large={7.5} offsetL={0.5}>
                  <Grid>
                     <Col large={12}>
                        <Label>Descripción amplia del curso:</Label>
                     </Col>
                     <Col large={12}>
                        <Input required type="text" placeholder="Texto" className="large" name="longDescription" as="textarea" />
                     </Col>
                  </Grid>
               </Col>
            </Grid>

            <Col large={12}>
               <Col large={12}>
                  <Label>Perfil de egreso:</Label>
               </Col>
               <Col large={12}>
                  <ReactQuill theme="snow" value={graduateText} onChange={setGraduateText} />
               </Col>
            </Col>

            <Grid className="maxMargin">
               <Col large={2} offsetL={10}>
                  <AppButton>{sections.length > 1 ? "CONTINUAR" : "GUARDAR"}</AppButton>
               </Col>
            </Grid>
         </FormStyled>
         <AppLoader isVisble={isSavigData} />
      </>
   );
}

const FormStyled = styled.form`
   padding: 2em 0;
   .buttonModal {
      margin-top: 2em;
   }
   textarea {
      font-family: Montserrat;
      resize: none;
      height: 160px;
   }
   & .maxMargin {
      margin-top: 1em;
   }
   & .imgs {
      & .row {
         width: 100%;
      }
   }

   & .buttonAction {
      text-align: center;
      height: 43px;
      box-sizing: border-box;
      user-select: none;

      &.disabled {
         pointer-events: none;
         color: grey;
         opacity: 0.5;
      }

      & span {
         font-size: 1.1em;
      }
   }
`;
